import { useInView, useSpring } from "framer-motion";
import React, { useEffect, useRef } from "react";
export default function AutomaticCounter(param) {
    var count = param.count, round = param.round, className = param.className;
    var spanRef = useRef(null);
    var inView = useInView(spanRef, {
        once: true,
        amount: "all"
    });
    var motionValue = useSpring(0, {
        mass: 1,
        stiffness: 100,
        damping: 20
    });
    useEffect(function() {
        if (inView) {
            motionValue.set(count);
            motionValue.on("change", function(value) {
                if (spanRef.current) spanRef.current.innerText = round ? round(value) : value;
            });
        }
    }, [
        count,
        inView
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        ref: spanRef,
        className: className
    }, count);
}

//# sourceMappingURL=AutomaticCounter.js.map